import type { FC } from 'react'

import { cn } from '@/lib/utils'

import { bakery } from '@/constants/site'

interface MapBlockProps {
    className?: string
}

const COLUMNS: Array<[number, number]> = [[0, 114], [138, 283], [301, 449], [467, 640]]
const ROWS: Array<[number, number]> = [[0, 96], [124, 240], [260, 361], [379, 440]]

const LABEL = {
    fill: '#857262',
    fontSize: 10,
    letterSpacing: '0.2em',
    fontWeight: 500
}

// A calm, schematic street plan of the corner around the bakery. The plan is drawn
// left to right, so its labels keep their anchors in the right-to-left page.
export const MapBlock: FC<MapBlockProps> = ({ className }) => (
    <div dir='ltr' className={cn('relative overflow-hidden bg-flour', className)}>
        <svg viewBox='0 0 640 440' preserveAspectRatio='xMidYMid slice' className='absolute inset-0 size-full' role='img' aria-labelledby='map-title map-description'>
            <title id='map-title'>نقشه‌ی La Douceur</title>
            <desc id='map-description'>{`La Douceur در نشانی ${bakery.fullAddress} است؛ در لیندن رو، میان خیابان هاثورن و خیابان کلوو، دو بلوک پایین‌تر از خیابان میرتل.`}</desc>

            <defs>
                <pattern id='map-park' width='8' height='8' patternUnits='userSpaceOnUse' patternTransform='rotate(45)'>
                    <line x1='0' y1='0' x2='0' y2='8' stroke='#d8ceb9' strokeWidth='1.2' />
                </pattern>
            </defs>

            <rect width='640' height='440' fill='#f7f2ea' />

            {ROWS.map(([top, bottom]) => COLUMNS.map(([left, right]) => {
                const isPark = left === 301 && top === 260

                return (
                    <rect
                        key={`${left}-${top}`}
                        x={left + 4}
                        y={top + 4}
                        width={right - left - 8}
                        height={bottom - top - 8}
                        rx='3'
                        fill={isPark ? 'url(#map-park)' : '#ebe2d4'}
                        stroke={isPark ? '#d8ceb9' : 'none'}
                    />
                )
            }))}

            <text x='454' y='114' style={{ ...LABEL, fontSize: 11 }}>خیابان میرتل</text>
            <text x='160' y='253.5' style={LABEL}>لیندن رو</text>
            <text x='488' y='373.5' style={LABEL}>ویلو پلیس</text>
            <text x='296' y='70' transform='rotate(90 296 70)' style={LABEL}>خیابان هاثورن</text>
            <text x='462' y='300' transform='rotate(90 462 300)' style={LABEL}>خیابان کلوو</text>
            <text x='130' y='330' transform='rotate(90 130 330)' style={LABEL}>خیابان گرند</text>
            <text x='375' y='318' textAnchor='middle' style={{ ...LABEL, fill: '#9a8775', letterSpacing: '0.16em' }}>میدان لیندن</text>

            <g transform='translate(596 34)'>
                <line x1='0' y1='14' x2='0' y2='-6' stroke='#857262' strokeWidth='1' />
                <path d='M -4 -2 L 0 -9 L 4 -2' fill='none' stroke='#857262' strokeWidth='1' />
                <text x='0' y='28' textAnchor='middle' style={{ ...LABEL, letterSpacing: '0.1em' }}>شمال</text>
            </g>

            <circle cx='364' cy='236' r='20' fill='#9a5b24' opacity='0.14' />
            <circle cx='364' cy='236' r='8' fill='#9a5b24' stroke='#f7f2ea' strokeWidth='3' />

            <g transform='translate(384 168)'>
                <rect width='150' height='50' rx='2' fill='#2a1c13' />
                <text lang='fr' x='14' y='24' style={{ fill: '#f7f2ea', fontFamily: 'var(--font-heading)', fontSize: 19, letterSpacing: '0.08em' }}>La Douceur</text>
                <text lang='en' x='14' y='39' style={{ fill: '#cdbfad', fontSize: 9.5, letterSpacing: '0.14em', fontWeight: 500 }}>{bakery.street.toUpperCase()}</text>
            </g>
        </svg>
    </div>
)
